module.exports = __webpack_public_path__ + "img/icon_kqmj.788c2693.png";